
export default {
  name: 'SubscribeLayout',
}
